<template>
  <div class="episodes-container">
    <!-- 标题和操作按钮 -->
    <div class="header">
      <div class="title-container">
        <div class="title-line"></div>
        <h2>分集管理</h2>
      </div>
      <div class="actions">
        <el-button type="primary" @click="RefreshData">刷新数据</el-button>
        <el-button type="primary" @click="showAddDialog">新增分集</el-button>
        <el-button type="success" @click="showBatchUploadDialog">批量上传分集</el-button>
        <el-button type="danger" @click="batchDelete" :disabled="selectedEpisodes.length === 0">删除分集</el-button>
      </div>
    </div>

    <!-- 内容区域 - 整合过滤搜索、表格和分页 -->
    <div class="content-block">
      <!-- 顶部筛选区域 -->
      <div class="filter-container">
        <el-form :inline="true" :model="filterForm">
          <el-form-item label="作品名称">
            <el-select v-model="filterForm.workId" placeholder="请选择作品" clearable filterable style="width: 200px">
              <el-option v-for="work in worksList" :key="work.id" :label="work.title" :value="work.id" />
            </el-select>
          </el-form-item>
          <el-form-item label="发布时间">
            <el-date-picker v-model="filterForm.dateRange" type="daterange" range-separator="至" start-placeholder="开始日期"
              end-placeholder="结束日期" value-format="YYYY-MM-DD" />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleSearch">查询</el-button>
            <el-button @click="handleReset">重置</el-button>
          </el-form-item>
        </el-form>
      </div>

      <!-- 数据表格 -->
      <div class="table-container">
        <el-table :data="tableData" border style="width: 100%" @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="40" />
          <el-table-column prop="id" label="作品ID" width="80" align="center" />
          <el-table-column prop="title" label="作品名称" width="180"  align="center"/>
          <el-table-column prop="episode_no" label="作品集数" width="85" align="center" />
          <el-table-column label="状态" width="100"   align="center">
            <template #default="{ row }">
              <el-tag :type="getStatusType(row.status)">{{ getStatusText(row.status) }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="付费类型" width="100"  align="center">
            <template #default="{ row }">
              <el-tag :type="row.is_free == 0 ? 'primary' : 'success'">{{ row.is_free == 0 ? '单集付费' : '免费视频' }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="视频预览" width="110"  align="center">
            <template #default="{ row }">
              <el-button size="small" type="primary" @click="handlePreview(row)">预览视频</el-button>
            </template>
          </el-table-column>
          <el-table-column prop="todayRevenue" label="今日收益" width="100"  align="center">
            <template #default="{ row }">
              ¥{{ row.todayRevenue || 0 }}
            </template>
          </el-table-column>
          <el-table-column prop="price" label="作品单价" width="90"  align="center">
            <template #default="{ row }">
              ¥{{ row.price || 0 }}
            </template>
          </el-table-column>
          <el-table-column prop="points" label="作品积分" width="90"  align="center">
            <template #default="{ row }">
              {{ row.points || 0 }}
            </template>
          </el-table-column>
          <el-table-column prop="mixcut" label="混剪分成" width="90"  align="center">
            <template #default="{ row }">
              {{ row.mixcut || 0 }}%
            </template>
          </el-table-column>
          <el-table-column prop="createtime" label="创建时间" width="180"  align="center"/>
                    <el-table-column prop="updatetime" label="修改时间" width="180" align="center" />
          <el-table-column label="操作" width="180" fixed="right">
            <template #default="{ row }">
              <el-button size="small" @click="showEditDialog(row)">编辑</el-button>
              <el-button size="small" type="danger" @click="handleDelete(row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 分页 -->
      <div class="pagination-container">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :current-page="pagination.currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pagination.pageSize"
          layout="total, sizes, prev, pager, next, jumper" :total="pagination.total" />
      </div>
    </div>

    <!-- 新增/编辑对话框 -->
    <el-dialog :title="dialogTitle" v-model="dialogVisible" width="50%">
      <el-form :model="episodeForm" label-width="100px">
        <el-form-item label="视频上传">
          <!-- 上传组件 -->
          <div class="video-upload-container">
            <!-- 上传按钮区域（非上传状态显示） -->
            <div v-if="!uploading && !selectedFile && !episodeForm.videoUrl" class="upload-button-area">
              <el-upload action="#" :auto-upload="false" :show-file-list="false" :before-upload="beforeFileUpload"
                accept=".mp4" :on-change="handleFileChange">
                <template #trigger>
                  <el-button type="primary">点击上传</el-button>
                </template>
              </el-upload>
              <div class="upload-tip">仅支持MP4格式视频文件，文件大小不能超过200MB</div>
            </div>

            <!-- 视频预览区域（选择文件后显示或已有视频时显示） -->
            <div v-if="(selectedFile && !uploading) || episodeForm.videoUrl" class="video-preview-area">
              <div class="video-thumbnail">
                <video :src="videoObjectUrl" class="thumbnail-video" :controls="!uploading" muted></video>
                <div class="video-actions">
                  <el-button size="small" @click="clearSelectedFile">
                    重新选择
                  </el-button>
                  <el-button v-if="!episodeForm.videoUrl" type="primary" size="small" @click="startUpload">
                    开始上传
                  </el-button>
                  <el-button v-else type="success" size="small" :disabled="true">
                    ✓ 上传成功
                  </el-button>
                </div>
              </div>
            </div>

            <!-- 上传中状态 -->
            <div v-if="uploading" class="uploading-container">
              <div class="video-thumbnail-uploading">
                <video :src="videoObjectUrl" class="thumbnail-video" :controls="!uploading" muted></video>
                <!-- 蒙版层 -->
                <div class="upload-overlay">
                  <div class="overlay-content">
                    <el-button type="danger" size="large" @click="cancelUpload" class="cancel-upload-btn">
                      取消上传
                    </el-button>
                  </div>
                </div>
                <!-- 底部进度条 -->
                <div class="bottom-progress">
                  <div class="progress-bar-container">
                    <div class="progress-bar" :style="{ width: uploadProgress + '%' }"></div>
                  </div>
                  <div class="progress-text">上传中: {{ uploadProgress }}%</div>
                </div>
              </div>
            </div>
          </div>
        </el-form-item>

        <el-form-item label="作品名称">
          <el-select v-model="episodeForm.workId" placeholder="请选择作品" @change="handleWorkChange" filterable
            style="width:100%">
            <el-option v-for="work in worksList" :key="work.id" :label="work.title" :value="work.id" />
          </el-select>
        </el-form-item>

        <el-form-item label="集数">
          <el-input v-model="episodeForm.episodeNum" :disabled="true" />
        </el-form-item>

        <el-form-item label="作品单价">
          <el-input-number v-model="episodeForm.price" :precision="2" :min="0" :step="0.1" />
        </el-form-item>

        <el-form-item label="作品积分">
          <el-input-number v-model="episodeForm.points" :min="60" :step="1" />
        </el-form-item>

        <el-form-item label="混剪分成(%)">
          <el-input-number v-model="episodeForm.mixCutRatio" :min="60" :max="100" :step="1" />
        </el-form-item>

        <el-form-item label="付费类型">
          <el-select v-model="episodeForm.payType" placeholder="请选择付费类型" style="width: 100%">
            <el-option label="免费" value="1"></el-option>
            <el-option label="付费" value="0"></el-option>
          </el-select>
        </el-form-item>
      </el-form>

      <template #footer>
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitForm">确认</el-button>
      </template>
    </el-dialog>

    <!-- 批量上传分集弹窗 -->
    <el-dialog v-model="batchUploadDialogVisible" title="批量上传分集" width="80%" :close-on-click-modal="false">
      <div class="batch-upload-container">
        <!-- 作品选择和参数设置 -->
        <el-form :model="batchUploadForm" label-width="100px">
          <el-form-item label="作品名称">
            <el-select v-model="batchUploadForm.workId" placeholder="请选择作品" @change="handleBatchWorkChange" filterable style="width:100%">
              <el-option v-for="work in worksList" :key="work.id" :label="work.title" :value="work.id" />
            </el-select>
          </el-form-item>

          <el-form-item label="作品单价">
            <el-input-number v-model="batchUploadForm.price" :precision="2" :min="0" :step="0.1" />
          </el-form-item>

          <el-form-item label="作品积分">
            <el-input-number v-model="batchUploadForm.points" :min="60" :step="1" />
          </el-form-item>

          <el-form-item label="混剪分成(%)">
            <el-input-number v-model="batchUploadForm.mixCutRatio" :min="60" :max="100" :step="1" />
          </el-form-item>

          <el-form-item label="付费类型">
            <el-select v-model="batchUploadForm.payType" placeholder="请选择付费类型" style="width: 100%">
              <el-option label="免费" value="1"></el-option>
              <el-option label="付费" value="0"></el-option>
            </el-select>
          </el-form-item>
        </el-form>

        <!-- 文件选择区域 -->
        <div class="batch-file-upload">
          <el-upload
            action="#"
            :auto-upload="false"
            :multiple="true"
            :show-file-list="false"
            :before-upload="beforeBatchFileUpload"
            accept=".mp4"
            :on-change="handleBatchFileChange"
          >
            <template #trigger>
              <el-button type="primary">选择多个视频文件</el-button>
            </template>
            <div class="upload-tip">支持多选MP4格式视频文件，每个文件大小不能超过200MB，视频名称将按1,2,3,4...顺序对应集数</div>
          </el-upload>
        </div>

        <!-- 文件列表表格 -->
        <div class="batch-file-table" v-if="batchUploadFiles.length > 0">
          <h4>已选择文件列表 (共{{ batchUploadFiles.length }}个文件)</h4>
          <div class="table-scroll-container">
            <el-table :data="batchUploadFiles" border style="width: 100%" max-height="300">
              <el-table-column label="序号" width="60" align="center">
                <template #default="{ $index }">
                  {{ $index + 1 }}
                </template>
              </el-table-column>
              <el-table-column label="视频预览" width="100" align="center">
                <template #default="{ row }">
                  <el-button size="small" type="primary" @click="previewBatchVideo(row)">预览</el-button>
                </template>
              </el-table-column>
              <el-table-column prop="name" label="视频名称" min-width="150" align="center" />
              <el-table-column label="文件大小" width="100" align="center">
                <template #default="{ row }">
                  {{ formatFileSize(row.size) }}
                </template>
              </el-table-column>
              <el-table-column label="视频时长(秒)" width="100" align="center">
                <template #default="{ row }">
                  {{ row.duration || 0 }}
                </template>
              </el-table-column>
              <el-table-column label="对应集数" width="100" align="center">
                <template #default="{ row }">
                  {{ getEpisodeNumberFromFileName(row.name) }}
                </template>
              </el-table-column>
              <el-table-column label="上传状态" width="150" align="center">
                <template #default="{ row }">
                  <div v-if="row.uploadStatus === 'uploading'">
                    <div class="upload-progress-container">
                      <div class="progress-box" :class="getProgressBoxClass(row.uploadStatus)">
                        <div class="progress-fill" :style="{ width: (row.uploadProgress || 0) + '%' }"></div>
                        <div class="progress-text">{{ row.uploadProgress || 0 }}%</div>
                      </div>
                    </div>
                  </div>
                  <div v-else>
                    <el-tag :type="getUploadStatusType(row.uploadStatus)">
                      {{ getUploadStatusText(row.uploadStatus) }}
                    </el-tag>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="添加状态" width="120" align="center">
                <template #default="{ row }">
                  <el-tag :type="getAddStatusType(row.addStatus)">
                    {{ getAddStatusText(row.addStatus) }}
                  </el-tag>
                </template>
              </el-table-column>
              <el-table-column label="视频路径" min-width="200" align="center">
                <template #default="{ row }">
                  <span class="file-path">{{ row.videoUrl || '未上传' }}</span>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="100" align="center">
                <template #default="{ $index }">
                  <el-button size="small" type="danger" @click="removeBatchFile($index)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>

      <template #footer>
        <el-button @click="batchUploadDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="startBatchUpload" :disabled="batchUploading || batchUploadFiles.length === 0 || !batchUploadForm.workId">
          {{ batchUploading ? '上传中...' : '开始批量上传' }}
        </el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { ElMessage } from 'element-plus'
import Hls from 'hls.js'

export default {
  name: 'EpisodesView',
  data() {
    return {
      filterForm: {
        workId: '',
        dateRange: []
      },
      tableData: [],
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 1
      },
      selectedEpisodes: [],
      dialogVisible: false,
      dialogTitle: '新增分集',
      episodeForm: {
        id: '',
        workId: '',
        workName: '',
        episodeNum: '',
        videoUrl: '',
        duration: 0,
        price: 0.6,
        points: 60,
        mixCutRatio: 60,
        payType: '0'
      },
      isEditMode: false,
      worksList: [],
      uploading: false,
      uploadProgress: 0,
      uploadController: null,
      selectedFile: null,
      videoObjectUrl: null,
      // 批量上传相关数据
      batchUploadDialogVisible: false,
      batchUploadFiles: [],
      batchUploadForm: {
        workId: '',
        workName: '',
        price: 0.6,
        points: 60,
        mixCutRatio: 60,
        payType: '0'
      },
      batchUploading: false,
      currentUploadIndex: 0,
      // 保存上一次设置的价格和积分
      lastPriceSettings: {},
      // HLS实例
      hlsInstance: null,
      // 当前预览对话框实例
      currentPreviewDialog: null
    }
  },

  async created() {
    await this.fetchWorksList()
    const workId = this.$route.query.workId
    if (workId) {
      this.filterForm.workId = Number(workId)
    }
    this.fetchData()
  },

  methods: {
    RefreshData() {
      this.fetchData()
    },

    handleSelectionChange(val) {
      this.selectedEpisodes = val
    },

    showAddDialog() {
      this.dialogTitle = '新增分集'
      this.isEditMode = false
      
      // 使用上一次设置的价格和积分，如果没有则使用默认值
      const lastSettings = this.lastPriceSettings[this.episodeForm.workId] || {}
      
      this.episodeForm = {
        id: '',
        workId: '',
        workName: '',
        episodeNum: '',
        videoUrl: '',
        price: lastSettings.price || 0.6,
        points: lastSettings.points || 60,
        mixCutRatio: lastSettings.mixCutRatio || 60,
        payType: lastSettings.payType || '0'
      }
      this.selectedFile = null
      this.uploading = false
      this.uploadProgress = 0
      if (this.uploadController) {
        this.uploadController.abort()
        this.uploadController = null
      }
      if (this.videoObjectUrl) {
        URL.revokeObjectURL(this.videoObjectUrl)
        this.videoObjectUrl = null
      }
      this.dialogVisible = true
    },

    async showEditDialog(row) {
      this.dialogTitle = '编辑分集'
      this.isEditMode = true
      
      if (this.worksList.length === 0) {
        await this.fetchWorksList()
      }
      
      this.episodeForm = {
        id: row.id,
        workId: row.drama_id || row.workId,
        workName: row.title || row.workName,
        episodeNum: row.episode_no || row.episodeNum,
        videoUrl: row.video_url || row.videoUrl,
        price: row.price || 0.6,
        points: row.points || 60,
        mixCutRatio: row.mixcut || row.mixCutRatio || 60,
        payType: row.is_free != null ? (row.is_free == 0 ? '0' : '1') : (row.payType || '0')
      }
      
      this.selectedFile = null
      if (this.videoObjectUrl) {
        URL.revokeObjectURL(this.videoObjectUrl)
        this.videoObjectUrl = null
      }
      
      if (this.episodeForm.videoUrl) {
        this.videoObjectUrl = this.episodeForm.videoUrl
      }
      
      this.$nextTick(() => {
        const workExists = this.worksList.some(work => String(work.id) === String(this.episodeForm.workId))
        if (!workExists) {
          this.fetchWorksList().then(() => {
            const selectedWork = this.worksList.find(w => String(w.id) === String(this.episodeForm.workId))
            if (selectedWork) {
              this.episodeForm.workName = selectedWork.title || selectedWork.name || ''
            }
          })
        } else {
          const selectedWork = this.worksList.find(w => String(w.id) === String(this.episodeForm.workId))
          if (selectedWork) {
            this.episodeForm.workName = selectedWork.title || selectedWork.name || ''
          }
        }
      })
      
      this.dialogVisible = true
    },

    async submitForm() {
      if (!this.episodeForm.workId) {
        ElMessage.error('请选择作品')
        return
      }
      if (!this.episodeForm.videoUrl) {
        ElMessage.error('请上传视频文件')
        return
      }

      try {
        if (this.isEditMode) {
          const response = await this.$axios.post('/api/episodes/update', this.episodeForm)
          if (response.code === 1) {
            ElMessage.success(response.msg || '更新成功')
            this.fetchData()
          } else {
            ElMessage.error(response.msg || '更新失败')
          }
        } else {
          const response = await this.$axios.post('/api/episodes/add', this.episodeForm)
          if (response.code === 1) {
            ElMessage.success(response.msg || '添加成功')
            
            // 保存当前设置的价格和积分到上一次设置中
            if (this.episodeForm.workId) {
              this.lastPriceSettings[this.episodeForm.workId] = {
                price: this.episodeForm.price,
                points: this.episodeForm.points,
                mixCutRatio: this.episodeForm.mixCutRatio,
                payType: this.episodeForm.payType
              }
            }
            
            this.episodeForm = {
              id: '',
              workId: '',
              workName: '',
              episodeNum: '',
              videoUrl: '',
              price: 0.6,
              points: 60,
              mixCutRatio: 60,
              payType: '0'
            }
            this.videoObjectUrl=null
            this.fetchWorksList()
            this.fetchData()
          } else {
            ElMessage.error(response.msg || '添加失败')
          }
        }
        this.dialogVisible = false
      } catch (err) {
        ElMessage.error('提交失败: ' + (err?.message || '未知错误'))
      }
    },

    batchDelete() {
      this.$confirm('确定要删除选中的分集吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const ids = this.selectedEpisodes.map(item => item.id)
        try {
          const response = await this.$axios.post('/api/Bloger/episodesbatchDelete', { ids })
          console.log('批量删除响应:', response)
          if (response.code !== 1) {
            ElMessage.error(response.message || response.msg || '删除失败')
            return
          }
          ElMessage.success(response.msg || '删除成功')
          this.fetchData()
          this.selectedEpisodes = []
        } catch (err) {
          ElMessage.error('删除失败: ' + (err?.message || '未知错误'))
        }
      }).catch(() => { })
    },

    handleDelete(row) {
      this.$confirm('确定要删除这个分集吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          const response = await this.$axios.post('/api/Bloger/episodesbatchDelete', { ids: [row.id] })
          console.log('删除响应:', response)
          if (response.code !== 1) {
            ElMessage.error(response.message || response.msg || '删除失败')
            return
          }
          ElMessage.success(response.msg || '删除成功')
          this.fetchData()
        } catch (err) {
          ElMessage.error('删除失败: ' + (err?.message || '未知错误'))
        }
      }).catch(() => { })
    },

    handlePreview(row) {
      const videoUrl = row.video_url || row.videoUrl
      if (!videoUrl) {
        ElMessage.error('视频链接不存在')
        return
      }

      const isM3U8 = videoUrl.toLowerCase().endsWith('.m3u8')
      
      // 创建视频播放器
      const videoId = 'video-preview-' + Date.now()
      const videoHtml = `
        <div style="text-align:center; max-height:85vh; overflow:hidden">
          <video id="${videoId}" controls autoplay style="max-width:100%; max-height:85vh; width:auto; height:auto; object-fit:contain">
            ${!isM3U8 ? `<source src="${videoUrl}" type="video/mp4">` : ''}
            您的浏览器不支持视频播放
          </video>
          <div style="margin-top:10px; color:#666; font-size:12px;">
            ${isM3U8 ? 'HLS流媒体格式 (使用HLS.js播放)' : 'MP4视频格式'}
          </div>
        </div>
      `

      // 创建对话框实例
      const dialogInstance = this.$confirm('', '作品预览', {
        showCancelButton: false,
        showConfirmButton: false,
        closeOnClickModal: true,
        closeOnPressEscape: true,
        customClass: 'video-preview-modal',
        width: '80%',
        message: videoHtml,
        dangerouslyUseHTMLString: true,
        beforeClose: (action, instance, done) => {
          // 清理HLS实例
          if (this.hlsInstance) {
            this.hlsInstance.destroy()
            this.hlsInstance = null
          }
          done()
        }
      }).then(() => {
        // 对话框关闭后的处理
        if (this.hlsInstance) {
          this.hlsInstance.destroy()
          this.hlsInstance = null
        }
      }).catch(() => {
        // 对话框关闭后的处理
        if (this.hlsInstance) {
          this.hlsInstance.destroy()
          this.hlsInstance = null
        }
      })

      // 保存对话框实例以便手动关闭
      this.currentPreviewDialog = dialogInstance

      // 在对话框显示后初始化HLS播放器
      this.$nextTick(() => {
        const videoElement = document.getElementById(videoId)
        if (videoElement && isM3U8) {
          if (Hls.isSupported()) {
            this.hlsInstance = new Hls({
              enableWorker: false,
              lowLatencyMode: true,
              backBufferLength: 90,
              debug: false,
              maxBufferLength: 30,
              maxMaxBufferLength: 600,
              maxBufferSize: 60 * 1000 * 1000,
              maxBufferHole: 0.5,
              liveSyncDurationCount: 3,
              liveMaxLatencyDurationCount: 10,
              enableSoftwareAES: true,
              stretchShortVideoTrack: true,
              autoStartLoad: true,
              startPosition: -1
            })
            
            this.hlsInstance.loadSource(videoUrl)
            this.hlsInstance.attachMedia(videoElement)
            
            this.hlsInstance.on(Hls.Events.MANIFEST_PARSED, () => {
              console.log('HLS manifest parsed, attempting to play')
              videoElement.play().catch(e => {
                console.log('自动播放失败:', e)
                // 如果自动播放失败，显示播放按钮让用户手动点击
                videoElement.controls = true
              })
            })
            
            this.hlsInstance.on(Hls.Events.ERROR, (event, data) => {
              console.error('HLS error:', data)
              if (data.fatal) {
                switch (data.type) {
                  case Hls.ErrorTypes.NETWORK_ERROR:
                    console.log('网络错误，尝试重新加载')
                    this.hlsInstance.startLoad()
                    break
                  case Hls.ErrorTypes.MEDIA_ERROR:
                    console.log('媒体错误，尝试恢复')
                    this.hlsInstance.recoverMediaError()
                    break
                  default:
                    console.log('不可恢复的错误')
                    this.hlsInstance.destroy()
                    break
                }
              }
            })
            
            this.hlsInstance.on(Hls.Events.LEVEL_LOADED, (event, data) => {
              console.log('HLS level loaded:', data)
            })
            
          } else if (videoElement.canPlayType('application/vnd.apple.mpegurl')) {
            // Safari原生支持HLS
            videoElement.src = videoUrl
            videoElement.addEventListener('loadedmetadata', () => {
              videoElement.play().catch(e => {
                console.log('自动播放失败:', e)
                videoElement.controls = true
              })
            })
            videoElement.addEventListener('error', (e) => {
              console.error('Safari HLS播放错误:', e)
              ElMessage.error('视频播放失败，请检查视频链接')
            })
          } else {
            ElMessage.error('您的浏览器不支持HLS视频播放')
          }
        }
      })
    },

    async fetchData() {
      const params = {
        page: this.pagination.currentPage,
        pageSize: this.pagination.pageSize
      }
      if (this.filterForm.workId) params.workId = this.filterForm.workId
      if (this.filterForm.dateRange && this.filterForm.dateRange.length === 2) {
        params.startDate = this.filterForm.dateRange[0]
        params.endDate = this.filterForm.dateRange[1]
      }

      try {
        const response = await this.$axios.post('/api/Bloger/getEpisodes', params, {
          headers: { token: localStorage.getItem('token') || '' }
        })
        if (response && response.code === 1) {
          this.tableData = response.data || []
          this.pagination.total = (response.meta?.total_count || response.total || 0)
          ElMessage.success(response.msg || '数据获取成功')
        } else {
          ElMessage.error(response?.msg || '获取数据失败')
        }
      } catch (error) {
        console.error('获取分集数据失败:', error)
        ElMessage.error('获取分集数据失败')
      }
    },

    handleSearch() {
      this.pagination.currentPage = 1
      this.fetchData()
    },

    handleReset() {
      this.filterForm = { workId: '', dateRange: [] }
      this.handleSearch()
    },

    handleSizeChange(val) {
      this.pagination.pageSize = val
      this.fetchData()
    },

    handleCurrentChange(val) {
      this.pagination.currentPage = val
      this.fetchData()
    },

    async fetchWorksList() {
      try {
        const response = await this.$axios.get('/api/Bloger/getWorks', {
          headers: { token: localStorage.getItem('token') || '' }
        })
        if (response && response.code === 1) {
          this.worksList = response.data || []
          return this.worksList
        } else {
          ElMessage.error(response?.msg || '获取作品列表失败')
          return []
        }
      } catch (error) {
        console.error('获取作品列表失败:', error)
        ElMessage.error('获取作品列表失败')
        return []
      }
    },

    handleWorkChange(workId) {
      const selectedWork = this.worksList.find(w => String(w.id) === String(workId))
      if (selectedWork) {
        this.episodeForm.workName = selectedWork.title || selectedWork.name || ''
        if (!this.isEditMode) {
          this.episodeForm.episodeNum = (selectedWork.esp_count || 0) + 1
        }
      } else {
        this.episodeForm.workName = ''
        if (!this.isEditMode) {
          this.episodeForm.episodeNum = ''
        }
      }
    },

    // 状态相关方法
    getStatusType(status) {
      const statusMap = {
        0: 'warning',  // 审核中 - 黄色
        1: 'success',  // 正常 - 绿色
        2: 'danger'    // 下架 - 红色
      }
      return statusMap[status] || 'info'
    },

    getStatusText(status) {
      const statusMap = {
        0: '转码中',
        1: '正常',
        2: '下架'
      }
      return statusMap[status] || '未知状态'
    },

    // =============== 上传相关 ===============

    beforeFileUpload(file) {
      const name = file.name || ''
      const ext = name.substring(name.lastIndexOf('.') + 1).toLowerCase()
      if (ext !== 'mp4') {
        ElMessage.error('只支持MP4格式视频文件')
        return false
      }

      // 限制文件大小不能超过200MB
      const maxSize = 200 * 1024 * 1024 // 200MB
      if (file.size > maxSize) {
        const fileSizeMB = (file.size / (1024 * 1024)).toFixed(2)
        ElMessage.error(`文件大小不能超过200MB，当前文件大小为 ${fileSizeMB}MB`)
        return false
      }

      // 额外检查：文件不能为0字节
      if (file.size === 0) {
        ElMessage.error('文件为空，请选择有效的视频文件')
        return false
      }

      return true
    },

    generateRandomFileName(originalName) {
      const timestamp = Date.now()
      const randomStr = Math.random().toString(36).substring(2, 10)
      const ext = originalName.substring(originalName.lastIndexOf('.') + 1).toLowerCase()
      return `${timestamp}_${randomStr}.${ext}`
    },

    async doCustomUpload({ file, onProgress, onSuccess, onError }) {
      try {
        if (!file) {
          ElMessage.error('请选择文件')
          return onError?.(new Error('No file'))
        }

        const formData = new FormData()
        const randomFileName = this.generateRandomFileName(file.name)
        const renamedFile = new File([file], randomFileName, { type: file.type })
        formData.append('file', renamedFile)

        this.uploadController = new AbortController()
        this.uploading = true
        this.uploadProgress = 0

        const response = await this.$axios.post('api/Bloger/upload', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            'token': localStorage.getItem('token') || ''
          },
          signal: this.uploadController.signal,
          onUploadProgress: (evt) => {
            if (evt.total) {
              const percent = Math.round((evt.loaded * 100) / evt.total)
              this.uploadProgress = percent
              onProgress?.({ percent })
            }
          },
          timeout: 900000
        })

        this.uploading = false
        this.uploadProgress = 0
        this.uploadController = null

        if (response && response.code === 1) {
          const url = response.data?.url || response.url
          if (!url) {
            ElMessage.error('上传成功但未返回URL')
            return onError?.(new Error('No URL'))
          }
          this.episodeForm.videoUrl = url
          if (this.videoObjectUrl) {
            URL.revokeObjectURL(this.videoObjectUrl)
            this.videoObjectUrl = url
          }
          ElMessage.success('上传成功')
          onSuccess?.(response)
        } else {
          const msg = response?.message || response?.msg || '上传失败'
          ElMessage.error(msg)
          onError?.(new Error(msg))
        }
      } catch (error) {
        if (error?.message === 'canceled' || error?.name === 'AbortError') {
          this.uploading = false
          this.uploadProgress = 0
          this.uploadController = null
          return
        }

        console.error('上传失败:', error)
        let errorMsg = '上传失败'
        if (error?.response?.status === 413) {
          errorMsg = '文件太大，服务器限制文件大小'
        } else if (error?.code === 'ECONNABORTED') {
          errorMsg = '上传超时'
        }
        ElMessage.error(errorMsg)
        onError?.(new Error(errorMsg))
      }
    },

    previewVideo() {
      if (!this.episodeForm.videoUrl) {
        ElMessage.warning('请先上传视频')
        return
      }

      const isM3U8 = this.episodeForm.videoUrl.toLowerCase().endsWith('.m3u8')
      
      // 创建视频播放器
      const videoId = 'video-preview-form-' + Date.now()
      const videoHtml = `
        <div style="text-align:center; max-height:85vh; overflow:hidden">
          <video id="${videoId}" controls autoplay style="max-width:100%; max-height:85vh; width:auto; height:auto; object-fit:contain">
            ${!isM3U8 ? `<source src="${this.episodeForm.videoUrl}" type="video/mp4">` : ''}
            您的浏览器不支持视频播放
          </video>
          <div style="margin-top:10px; color:#666; font-size:12px;">
            ${isM3U8 ? 'HLS流媒体格式 (使用HLS.js播放)' : 'MP4视频格式'}
          </div>
        </div>
      `

      // 创建对话框实例
      const dialogInstance = this.$confirm('', '视频预览', {
        showCancelButton: false,
        showConfirmButton: false,
        closeOnClickModal: true,
        closeOnPressEscape: true,
        customClass: 'video-preview-modal',
        message: videoHtml,
        dangerouslyUseHTMLString: true,
        beforeClose: (action, instance, done) => {
          // 清理HLS实例
          if (this.hlsInstance) {
            this.hlsInstance.destroy()
            this.hlsInstance = null
          }
          done()
        }
      }).then(() => {
        // 对话框关闭后的处理
        if (this.hlsInstance) {
          this.hlsInstance.destroy()
          this.hlsInstance = null
        }
      }).catch(() => {
        // 对话框关闭后的处理
        if (this.hlsInstance) {
          this.hlsInstance.destroy()
          this.hlsInstance = null
        }
      })

      // 保存对话框实例以便手动关闭
      this.currentPreviewDialog = dialogInstance

      // 在对话框显示后初始化HLS播放器
      this.$nextTick(() => {
        const videoElement = document.getElementById(videoId)
        if (videoElement && isM3U8) {
          if (Hls.isSupported()) {
            this.hlsInstance = new Hls({
              enableWorker: false,
              lowLatencyMode: true,
              backBufferLength: 90,
              debug: false,
              maxBufferLength: 30,
              maxMaxBufferLength: 600,
              maxBufferSize: 60 * 1000 * 1000,
              maxBufferHole: 0.5,
              liveSyncDurationCount: 3,
              liveMaxLatencyDurationCount: 10,
              enableSoftwareAES: true,
              stretchShortVideoTrack: true,
              autoStartLoad: true,
              startPosition: -1
            })
            
            this.hlsInstance.loadSource(this.episodeForm.videoUrl)
            this.hlsInstance.attachMedia(videoElement)
            
            this.hlsInstance.on(Hls.Events.MANIFEST_PARSED, () => {
              console.log('HLS manifest parsed, attempting to play')
              videoElement.play().catch(e => {
                console.log('自动播放失败:', e)
                videoElement.controls = true
              })
            })
            
            this.hlsInstance.on(Hls.Events.ERROR, (event, data) => {
              console.error('HLS error:', data)
              if (data.fatal) {
                switch (data.type) {
                  case Hls.ErrorTypes.NETWORK_ERROR:
                    console.log('网络错误，尝试重新加载')
                    this.hlsInstance.startLoad()
                    break
                  case Hls.ErrorTypes.MEDIA_ERROR:
                    console.log('媒体错误，尝试恢复')
                    this.hlsInstance.recoverMediaError()
                    break
                  default:
                    console.log('不可恢复的错误')
                    this.hlsInstance.destroy()
                    break
                }
              }
            })
            
          } else if (videoElement.canPlayType('application/vnd.apple.mpegurl')) {
            // Safari原生支持HLS
            videoElement.src = this.episodeForm.videoUrl
            videoElement.addEventListener('loadedmetadata', () => {
              videoElement.play().catch(e => {
                console.log('自动播放失败:', e)
                videoElement.controls = true
              })
            })
            videoElement.addEventListener('error', (e) => {
              console.error('Safari HLS播放错误:', e)
              ElMessage.error('视频播放失败，请检查视频链接')
            })
          } else {
            ElMessage.error('您的浏览器不支持HLS视频播放')
          }
        }
      })
    },

    removeVideo() {
      this.episodeForm.videoUrl = ''
    },

    cancelUpload() {
      if (this.uploadController) {
        this.uploadController.abort()
        this.uploading = false
        this.uploadProgress = 0
        ElMessage.info('上传已取消')
      }
    },

    handleFileChange(file) {
      if (file) {
        this.selectedFile = file.raw
        this.videoObjectUrl = URL.createObjectURL(file.raw)
        
        this.getVideoDuration(file.raw).then(duration => {
          console.log('视频时长:', duration)
          this.episodeForm.duration = duration
        }).catch(error => {
          console.error('获取视频时长失败:', error)
        })
      }
    },

    getVideoDuration(file) {
      return new Promise((resolve, reject) => {
        const video = document.createElement('video')
        video.preload = 'metadata'
        
        video.onloadedmetadata = function() {
          window.URL.revokeObjectURL(video.src)
          resolve(Math.round(video.duration))
        }
        
        video.onerror = function() {
          window.URL.revokeObjectURL(video.src)
          reject(new Error('无法获取视频时长'))
        }
        
        video.src = URL.createObjectURL(file)
      })
    },

    clearSelectedFile() {
      this.selectedFile = null
      if (this.videoObjectUrl) {
        URL.revokeObjectURL(this.videoObjectUrl)
        this.videoObjectUrl = null
        this.episodeForm.videoUrl = ''
      }
    },

    startUpload() {
      if (!this.selectedFile) {
        ElMessage.error('请先选择文件')
        return
      }
      this.doCustomUpload({ file: this.selectedFile })
    },

    formatFileSize(bytes) {
      if (bytes === 0) return '0 B'
      const k = 1024
      const sizes = ['B', 'KB', 'MB', 'GB']
      const i = Math.floor(Math.log(bytes) / Math.log(k))
      return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i]
    },

    getEpisodeNumberFromFileName(fileName) {
      if (!fileName) return ''
      const match = fileName.match(/^(\d+)\.mp4$/i)
      if (match && match[1]) {
        return match[1]
      }
      return ''
    },

    // =============== 批量上传相关方法 ===============

    showBatchUploadDialog() {
      this.batchUploadDialogVisible = true
      this.batchUploadFiles = []
      this.batchUploadForm = {
        workId: '',
        workName: '',
        price: 0.6,
        points: 60,
        mixCutRatio: 60,
        payType: '0'
      }
      this.batchUploading = false
      this.currentUploadIndex = 0
    },

    beforeBatchFileUpload(file) {
      return this.beforeFileUpload(file)
    },

    async handleBatchFileChange(file, fileList) {
      if (file) {
        let duration = 0
        try {
          duration = await this.getVideoDuration(file.raw)
          console.log('视频时长:', duration)
        } catch (error) {
          console.error('获取视频时长失败:', error)
        }
        
        const fileInfo = {
          file: file.raw,
          name: file.name,
          size: file.size,
          duration: duration,
          uploadStatus: 'waiting',
          addStatus: 'waiting',
          videoUrl: '',
          objectUrl: URL.createObjectURL(file.raw),
          uploadProgress: 0
        }
        this.batchUploadFiles.push(fileInfo)
        
        this.sortBatchFiles()
      }
    },

    sortBatchFiles() {
      this.batchUploadFiles.sort((a, b) => {
        const numA = parseInt(a.name.match(/^(\d+)/)?.[1] || '999999')
        const numB = parseInt(b.name.match(/^(\d+)/)?.[1] || '999999')
        
        if (numA !== numB) {
          return numA - numB
        }
        
        return a.name.localeCompare(b.name)
      })
    },

    handleBatchWorkChange(workId) {
      const selectedWork = this.worksList.find(w => String(w.id) === String(workId))
      if (selectedWork) {
        this.batchUploadForm.workName = selectedWork.title || selectedWork.name || ''
      } else {
        this.batchUploadForm.workName = ''
      }
    },

    previewBatchVideo(row) {
      const videoUrl = row.objectUrl || row.videoUrl
      if (!videoUrl) {
        ElMessage.warning('无法预览该视频')
        return
      }

      const isM3U8 = videoUrl.toLowerCase().endsWith('.m3u8')
      
      // 创建视频播放器
      const videoId = 'video-preview-batch-' + Date.now()
      const videoHtml = `
        <div style="text-align:center; max-height:85vh; overflow:hidden">
          <video id="${videoId}" controls autoplay style="max-width:100%; max-height:85vh; width:auto; height:auto; object-fit:contain">
            ${!isM3U8 ? `<source src="${videoUrl}" type="video/mp4">` : ''}
            您的浏览器不支持视频播放
          </video>
          <div style="margin-top:10px; color:#666; font-size:12px;">
            ${isM3U8 ? 'HLS流媒体格式 (使用HLS.js播放)' : 'MP4视频格式'}
          </div>
        </div>
      `

      // 创建对话框实例
      const dialogInstance = this.$confirm('', '视频预览', {
        showCancelButton: false,
        showConfirmButton: false,
        closeOnClickModal: true,
        closeOnPressEscape: true,
        customClass: 'video-preview-modal',
        message: videoHtml,
        dangerouslyUseHTMLString: true,
        beforeClose: (action, instance, done) => {
          // 清理HLS实例
          if (this.hlsInstance) {
            this.hlsInstance.destroy()
            this.hlsInstance = null
          }
          done()
        }
      }).then(() => {
        // 对话框关闭后的处理
        if (this.hlsInstance) {
          this.hlsInstance.destroy()
          this.hlsInstance = null
        }
      }).catch(() => {
        // 对话框关闭后的处理
        if (this.hlsInstance) {
          this.hlsInstance.destroy()
          this.hlsInstance = null
        }
      })

      // 保存对话框实例以便手动关闭
      this.currentPreviewDialog = dialogInstance

      // 在对话框显示后初始化HLS播放器
      this.$nextTick(() => {
        const videoElement = document.getElementById(videoId)
        if (videoElement && isM3U8) {
          if (Hls.isSupported()) {
            this.hlsInstance = new Hls({
              enableWorker: false,
              lowLatencyMode: true,
              backBufferLength: 90,
              debug: false,
              maxBufferLength: 30,
              maxMaxBufferLength: 600,
              maxBufferSize: 60 * 1000 * 1000,
              maxBufferHole: 0.5,
              liveSyncDurationCount: 3,
              liveMaxLatencyDurationCount: 10,
              enableSoftwareAES: true,
              stretchShortVideoTrack: true,
              autoStartLoad: true,
              startPosition: -1
            })
            
            this.hlsInstance.loadSource(videoUrl)
            this.hlsInstance.attachMedia(videoElement)
            
            this.hlsInstance.on(Hls.Events.MANIFEST_PARSED, () => {
              console.log('HLS manifest parsed, attempting to play')
              videoElement.play().catch(e => {
                console.log('自动播放失败:', e)
                videoElement.controls = true
              })
            })
            
            this.hlsInstance.on(Hls.Events.ERROR, (event, data) => {
              console.error('HLS error:', data)
              if (data.fatal) {
                switch (data.type) {
                  case Hls.ErrorTypes.NETWORK_ERROR:
                    console.log('网络错误，尝试重新加载')
                    this.hlsInstance.startLoad()
                    break
                  case Hls.ErrorTypes.MEDIA_ERROR:
                    console.log('媒体错误，尝试恢复')
                    this.hlsInstance.recoverMediaError()
                    break
                  default:
                    console.log('不可恢复的错误')
                    this.hlsInstance.destroy()
                    break
                }
              }
            })
            
          } else if (videoElement.canPlayType('application/vnd.apple.mpegurl')) {
            // Safari原生支持HLS
            videoElement.src = videoUrl
            videoElement.addEventListener('loadedmetadata', () => {
              videoElement.play().catch(e => {
                console.log('自动播放失败:', e)
                videoElement.controls = true
              })
            })
            videoElement.addEventListener('error', (e) => {
              console.error('Safari HLS播放错误:', e)
              ElMessage.error('视频播放失败，请检查视频链接')
            })
          } else {
            ElMessage.error('您的浏览器不支持HLS视频播放')
          }
        }
      })
    },

    removeBatchFile(index) {
      const file = this.batchUploadFiles[index]
      if (file.objectUrl) {
        URL.revokeObjectURL(file.objectUrl)
      }
      this.batchUploadFiles.splice(index, 1)
    },

    getUploadStatusType(status) {
      const statusMap = {
        waiting: 'info',
        uploading: 'warning',
        success: 'success',
        error: 'danger'
      }
      return statusMap[status] || 'info'
    },

    getUploadStatusText(status) {
      const statusMap = {
        waiting: '等待上传',
        uploading: '上传中',
        success: '上传成功',
        error: '上传失败'
      }
      return statusMap[status] || '未知状态'
    },

    getAddStatusType(status) {
      const statusMap = {
        waiting: 'info',
        success: 'success',
        error: 'danger'
      }
      return statusMap[status] || 'info'
    },

    getAddStatusText(status) {
      const statusMap = {
        waiting: '等待添加',
        success: '添加成功',
        error: '添加失败'
      }
      return statusMap[status] || '未知状态'
    },

    getProgressBoxClass(status) {
      const classMap = {
        uploading: 'uploading-progress',
        success: 'success-progress',
        error: 'error-progress',
        waiting: 'waiting-progress'
      }
      return classMap[status] || 'waiting-progress'
    },

    getStatusBoxClass(status) {
      const classMap = {
        success: 'success-status',
        error: 'error-status',
        waiting: 'waiting-status'
      }
      return classMap[status] || 'waiting-status'
    },

    async uploadBatchFile(file, onProgress) {
      try {
        const formData = new FormData()
        const randomFileName = this.generateRandomFileName(file.name)
        const renamedFile = new File([file], randomFileName, { type: file.type })
        formData.append('file', renamedFile)

        const response = await this.$axios.post('api/Bloger/upload', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            'token': localStorage.getItem('token') || ''
          },
          timeout: 900000,
          onUploadProgress: (evt) => {
            if (evt.total && onProgress) {
              const percent = Math.round((evt.loaded * 100) / evt.total)
              onProgress(percent)
            }
          }
        })

        if (response && response.code === 1) {
          const url = response.data?.url || response.url
          return url
        } else {
          const msg = response?.message || response?.msg || '上传失败'
          ElMessage.error(`文件上传失败: ${msg}`)
          return null
        }
      } catch (error) {
        console.error('文件上传失败:', error)
        let errorMsg = '上传失败'
        if (error?.response?.status === 413) {
          errorMsg = '文件太大，服务器限制文件大小'
        } else if (error?.code === 'ECONNABORTED') {
          errorMsg = '上传超时'
        }
        ElMessage.error(`文件上传失败: ${errorMsg}`)
        return null
      }
    },

    async startBatchUpload() {
      if (!this.batchUploadForm.workId) {
        ElMessage.error('请选择作品')
        return
      }

      if (this.batchUploadFiles.length === 0) {
        ElMessage.error('请选择要上传的文件')
        return
      }

      this.batchUploading = true
      this.currentUploadIndex = 0

      for (let i = 0; i < this.batchUploadFiles.length; i++) {
        const fileInfo = this.batchUploadFiles[i]
        this.currentUploadIndex = i
        
        fileInfo.uploadStatus = 'uploading'
        fileInfo.uploadProgress = 0
        
        try {
          const videoUrl = await this.uploadBatchFile(fileInfo.file, (progress) => {
            fileInfo.uploadProgress = progress
          })
          
          if (videoUrl) {
            fileInfo.uploadStatus = 'success'
            fileInfo.videoUrl = videoUrl
            
            const episodeData = {
              workId: this.batchUploadForm.workId,
              episodeNum: this.getEpisodeNumberFromFileName(fileInfo.name),
              videoUrl: videoUrl,
              duration: fileInfo.duration,
              price: this.batchUploadForm.price,
              points: this.batchUploadForm.points,
              mixCutRatio: this.batchUploadForm.mixCutRatio,
              payType: this.batchUploadForm.payType
            }
            
            try {
              const response = await this.$axios.post('/api/episodes/add', episodeData)
              if (response.code === 1) {
                fileInfo.addStatus = 'success'
                ElMessage.success(`文件 ${fileInfo.name} 上传并添加成功`)
              } else {
                fileInfo.addStatus = 'error'
                ElMessage.error(`文件 ${fileInfo.name} 上传成功但添加失败: ${response.msg}`)
              }
            } catch (error) {
              fileInfo.addStatus = 'error'
              ElMessage.error(`文件 ${fileInfo.name} 上传成功但添加失败: ${error.message}`)
            }
          } else {
            fileInfo.uploadStatus = 'error'
            fileInfo.addStatus = 'error'
            ElMessage.error(`文件 ${fileInfo.name} 上传失败`)
          }
        } catch (error) {
          fileInfo.uploadStatus = 'error'
          fileInfo.addStatus = 'error'
          ElMessage.error(`文件 ${fileInfo.name} 上传失败: ${error.message}`)
        }
      }

      this.batchUploading = false
      ElMessage.success('批量上传完成')
    }
  }
}
</script>

<style scoped>
.episodes-container {
  padding: 20px;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.title-container {
  display: flex;
  align-items: center;
}

.title-line {
  width: 4px;
  height: 24px;
  background-color: #409eff;
  margin-right: 12px;
  border-radius: 2px;
}

.header h2 {
  margin: 0;
  color: #303133;
  font-size: 20px;
  font-weight: 600;
}

.actions {
  display: flex;
  gap: 12px;
}

/* 内容块样式 */
.content-block {
  background: #ffffff;
  border: 1px solid #e4e7ed;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

.filter-container {
  background: #ffffff;
  padding: 20px;
  border-bottom: 1px solid #e4e7ed;
}

.table-container {
  padding: 0 20px;
}

.pagination-container {
  display: flex;
  justify-content: flex-start;
  padding: 20px;
  border-top: 1px solid #e4e7ed;
  background: #ffffff;
}

.video-upload-container {
  border: 1px solid #e4e7ed;
  border-radius: 8px;
  padding: 16px;
  background: #fafafa;
  width: 100%;
  min-height: 120px;
}

.upload-button-area {
  text-align: center;
  padding: 20px;
}

.upload-tip {
  margin-top: 12px;
  color: #909399;
  font-size: 14px;
}

.video-preview-area {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}

.video-thumbnail {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}

.thumbnail-video {
  width: 300px;
  max-width: 100%;
  border-radius: 6px;
  outline: none;
}

.video-actions {
  display: flex;
  gap: 8px;
  justify-content: center;
}

.uploading-container {
  display: flex;
  justify-content: center;
}

.video-thumbnail-uploading {
  position: relative;
  display: inline-block;
}

.upload-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.overlay-content {
  text-align: center;
}

.cancel-upload-btn {
  font-size: 16px;
  padding: 12px 24px;
}

.bottom-progress {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.8);
  padding: 8px;
  border-bottom-left-radius: 6px;
  border-bottom-right-radius: 6px;
}

.progress-bar-container {
  width: 100%;
  height: 6px;
  background: #555;
  border-radius: 3px;
  overflow: hidden;
}

.progress-bar {
  height: 100%;
  background: #409eff;
  transition: width 0.3s ease;
}

.progress-text {
  color: white;
  font-size: 12px;
  margin-top: 4px;
  text-align: center;
}

.batch-upload-container {
  max-height: 70vh;
  overflow-y: auto;
}

.batch-file-upload {
  margin: 20px 0;
  padding: 20px;
  border: 1px dashed #dcdfe6;
  border-radius: 8px;
  text-align: center;
  background: #fafafa;
}

.batch-file-table {
  margin-top: 20px;
}

.table-scroll-container {
  max-height: 300px;
  overflow-y: auto;
}

.file-path {
  font-family: monospace;
  font-size: 12px;
  color: #666;
  word-break: break-all;
}

.upload-progress-container {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 4px;
}

.progress-box {
  position: relative;
  width: 120px;
  height: 24px;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.progress-fill {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  border-radius: 12px;
  transition: width 0.3s ease;
}

.progress-text {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 600;
  color: #fff;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
  z-index: 2;
}

.uploading-progress {
  background-color: #e6f7ff;
  border: 1px solid #91d5ff;
}

.uploading-progress .progress-fill {
  background: linear-gradient(90deg, #1890ff, #40a9ff);
}

.success-progress {
  background-color: #f6ffed;
  border: 1px solid #b7eb8f;
}

.success-progress .progress-fill {
  background: linear-gradient(90deg, #52c41a, #73d13d);
}

.error-progress {
  background-color: #fff2f0;
  border: 1px solid #ffccc7;
}

.error-progress .progress-fill {
  background: linear-gradient(90deg, #ff4d4f, #ff7875);
}

.waiting-progress {
  background-color: #fafafa;
  border: 1px solid #d9d9d9;
}

.waiting-progress .progress-fill {
  background: linear-gradient(90deg, #bfbfbf, #d9d9d9);
}

.status-box {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
  min-width: 80px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.success-status {
  background-color: #f6ffed;
  border: 1px solid #b7eb8f;
  color: #52c41a;
}

.error-status {
  background-color: #fff2f0;
  border: 1px solid #ffccc7;
  color: #ff4d4f;
}

.waiting-status {
  background-color: #fafafa;
  border: 1px solid #d9d9d9;
  color: #8c8c8c;
}

:deep(.video-preview-modal) {
  .el-message-box__header {
    display: none;
  }
  
  .el-message-box__content {
    padding: 0;
  }
  
  .el-message-box__btns {
    display: none;
  }
}
</style>
